export type LocationDto = {
  state: string;
  commute: string;
};
export type MotivationDto = {
  motivation: string;
  workStyle: string;
};
export type WorkStyleDto = {
  workStyle: string;
};

export type DigitalLiteracyDto = {
  value: string;
};
export type ScorePhyEnvDto = {
  phyical: string;
  environmental: string;
  custom: string;
};

export type ToolExposureDto = {
  exposureType: string;
};

export type SectorInterestDto = {
  sectorType: string;
};
export type Scenario1Dto = {
  people: string;
};
export type Scenario2Dto = {
  ops: string;
};

export type ProbleSolvingDto = {
  role: string;
  style: string;
};
export type RoleAlignmentDto = {
  role: string;
};
export type ProblemStyleDto = {
  style: string;
};
export type DetailOrientationDto = {
  details: string;
};
export type StructurePreferenceDto = {
  answer: string;
};
export type AvailabilityDto = {
  answer: string;
};
export type CertificationsDto = {
  certificate: string;
};
export type StreuctureContextDto = {
  bilingual: string;
  reliableTransportation: string;
  caregivingDuties: string;
};

export type ContextNotesDto = {
  notes: string;
};
export const proficiency_options = [
  {
    label: '0',
    value: '0',
  },
  {
    label: '1',
    value: '1',
  },
  {
    label: '2',
    value: '2',
  },
  {
    label: '3',
    value: '3',
  },
  {
    label: '4',
    value: '4',
  },
  {
    label: '5',
    value: '5',
  },
];

export type CareerRoadMapDto = {
  id: number | null;
  question: string | undefined;
  answer: string | undefined;
  answer2?: string | undefined;
};

export type CareerRoadMapAnswers = {
  userId: string;
  region_location?: CareerRoadMapDto;
  motivation_vector?: CareerRoadMapDto;
  workstyle_vector?: CareerRoadMapDto;
  digital_literacy?: CareerRoadMapDto;
  tool_exposure?: CareerRoadMapDto;
  sector_interest?: CareerRoadMapDto;
  scenario_people?: CareerRoadMapDto;
  scenario_ops?: CareerRoadMapDto;
  role_alignment?: CareerRoadMapDto;
  problem_style?: CareerRoadMapDto;
  detail_orientation?: CareerRoadMapDto;
  physicality_score?: CareerRoadMapDto;
  facility_environment?: CareerRoadMapDto;
  customer_interaction?: CareerRoadMapDto;
  structure_preference?: CareerRoadMapDto;
  availability?: CareerRoadMapDto;
  certs_vector?: CareerRoadMapDto;
  green_orientation?: CareerRoadMapDto;
  structured_context?: CareerRoadMapDto;
  context_structured_bilingual?: CareerRoadMapDto;
  context_structured_transport?: CareerRoadMapDto;
  context_structured_caregiving?: CareerRoadMapDto;
  context_notes?: CareerRoadMapDto;
  isCareerRoadMapAssessmentComplete: boolean;
  isRoadmapAiGenerated?: boolean;
};

export const careerRoadMapIntitalAnswers: CareerRoadMapDto = {
  id: null,
  answer: undefined,
  question: undefined,
  answer2: undefined,
};
